var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center cursor-pointer",staticStyle:{"height":"100%"},on:{"click":_vm.handleClick}},[_vm._v("\n\t"+_vm._s(_vm.params.data.lowIssues +
		" | " +
		_vm.params.data.mediumIssues +
		" | " +
		_vm.params.data.highIssues)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }